/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Shots_BezierInputs */

const en_vc_shots_bezier = /** @type {(inputs: Vc_Shots_BezierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pen and Direct Selection tools editing Bézier anchors and handles in VectorCraft`)
};

const zh_vc_shots_bezier = /** @type {(inputs: Vc_Shots_BezierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VectorCraft 的钢笔和直接选择工具编辑贝塞尔锚点与手柄`)
};

/**
* | output |
* | --- |
* | "Pen and Direct Selection tools editing Bézier anchors and handles in VectorCraft" |
*
* @param {Vc_Shots_BezierInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_shots_bezier = /** @type {((inputs?: Vc_Shots_BezierInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Shots_BezierInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_shots_bezier(inputs)
	return zh_vc_shots_bezier(inputs)
});
export { vc_shots_bezier as "vc.shots.bezier" }